export const IS_CLIENT = typeof window !== "undefined";

export const IMAGE_TYPE = ["image/jpeg", "image/png"];
